<svg *ngIf="def"
     [attr.viewBox]="def.v"
     xmlns="http://www.w3.org/2000/svg"
     focusable="false"
     aria-hidden="true">
  <path *ngFor="let d of paths" [attr.d]="d"></path>
</svg>
